<!--
  @component

  The Icon Button component

  ```html
  <oc-icon-button-v1 elevated disabled icon-type="arrow-right" size="200" />
  ```
-->
<svelte:options
  customElement={{
    tag: "oc-icon-button-v1",
    props: {
      elevated: { type: "Boolean" },
      transparent: { type: "Boolean" },
      active: { type: "Boolean", reflect: true },
      disabled: { type: "Boolean", reflect: true },
      iconType: { type: "String", attribute: "icon-type" },
      size: { type: "String", reflect: true },
      a11yLabel: { type: "String", attribute: "a11y-label" }
    },
  }}
/>

<script lang="ts">
  import type { IconType } from "@otto-ec/icons";

  /**
 *
 *
 */
  export let elevated = false;
  /**
 *
 *
 */
  export let transparent = false;
  /**
 *
 *
 */
  export let disabled = false;
  /**
 *
 */
  export let iconType: IconType = "wishlist";
  /**
 *
 *
 */
  export let size: "50" | "100" = "50";
  /**
 *
 *
 */
  export let label = "";
</script>

<button
  type="button"
  class="icon-button {`icon-button--size-${size}`}"
  {disabled}
  class:icon-button--transparent={transparent}
  class:icon-button--disabled={disabled}
  class:icon-button--elevated={size === "50" && !transparent ? elevated : false}
  tabindex="0"
  aria-label={label}
>
  <oc-icon-v1
    class="icon-button__icon"
    class:icon-button__icon--disabled={disabled}
    type={iconType}
    size={"100"}
  />
</button>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "./IconButtonV1.config" as config;
  @use "../../../common/css/focus.scss";

  :host {
    @include config.oc-icon-button;
  }

  :host([size="50"]) {
    @include config.oc-icon-button-size-50;
  }

  :host([size="100"]) {
    @include config.oc-icon-button-size-100;
  }

  /*                 */
  .icon-button {
    position: relative;
    background-color: tokens.$oc-component-icon-button-default-background-color;
    border-radius: 50%;
    border: none;
    height: 32px;
    width: 32px;

    /*                                                */
    &:after {
      content: "";
      position: absolute;
      width: 48px;
      height: 48px;
      top: -8px;
      left: -8px;
      background-color: transparent;
    }

    /*                                    */
    &--size-100 {
      height: 48px;
      width: 48px;
    }

    &:hover:enabled {
      cursor: pointer;
      background-color: tokens.$oc-component-icon-button-default-background-color-hover;
    }

    &:active:enabled {
      cursor: pointer;
      background-color: tokens.$oc-component-icon-button-default-background-color-active;
    }

    &:focus:enabled {
      @include focus.styles();
    }

    &--transparent {
      background-color: tokens.$oc-component-icon-button-transparent-background-color;

      &:hover:enabled {
        background-color: tokens.$oc-component-icon-button-transparent-background-color-hover;
      }
      &:active:enabled {
        background-color: tokens.$oc-component-icon-button-transparent-background-color-active;
      }
    }

    &--elevated {
      &:not(.icon-button--transparent) {
        /*                                         */
        filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
        box-shadow: 0 1px 3px 1px rgb(0 0 0 / 15%);
      }
    }

    &__icon {
      fill: #222222;
      left: 50%;
      top: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      &--disabled {
        fill: tokens.$oc-component-icon-button-disabled-icon-color;
      }
    }
  }
</style>
